import { Helmet } from 'react-helmet-async';

const HelmetTabComponent = ({ title }: { title: string }) => {
    return (
        <Helmet>
            <title> {title} | آقای پرداخت</title>
        </Helmet>
    );
};

export default HelmetTabComponent;
